import React, { useState, useEffect, useContext } from "react";
import { Tabs, Tab, Box, Typography, CircularProgress } from "@mui/material";
import { onSnapshot } from "firebase/firestore";
import PropertyContext from "../contexts/PropertyContext";
import { propertyCollection } from "../utils/firestorePaths";

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const DispatchAssistant = () => {
  const [value, setValue] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDifficulty, setLoadingDifficulty] = useState(true);
  const [roomsByDifficulty, setRoomsByDifficulty] = useState([]);
  const { selectedProperty, selectedClient, rooms } = useContext(PropertyContext);
  //   rooms.map((room) => console.log(room));

  useEffect(() => {
    setLoading(true);
    const fetchEmployees = async () => {
      const employeesRef = propertyCollection(
        selectedClient,
        selectedProperty,
        "employees"
      );
      const unsubscribe = onSnapshot(employeesRef, (snapshot) => {
        const employees = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setEmployees(employees);
      });
    };
    fetchEmployees();
  }, [selectedProperty]);

  useEffect(() => {
    setLoading(true);
    const today = new Date();
    const dayIndex = value === 0 ? today.getDay() : (today.getDay() + 1) % 7;
    const dayName = daysOfWeek[dayIndex];

    const filtered = employees.filter(
      (employee) => employee.schedule && employee.schedule[dayName]
    );
    console.log(filtered);
    setFilteredEmployees(filtered);
    setLoading(false);
  }, [value, employees]);

  useEffect(() => {
    // Difficulty is maintained server-side by the onRoomUpdated cloud function
    // and stored on each unit as `calculatedDifficulty`. Pull the down rooms
    // straight from the document instead of recalculating on the client.
    const downRooms = rooms
      .filter((room) => room.status === "Down")
      .map((room) => ({ ...room, difficulty: room.calculatedDifficulty || 0 }))
      .sort((a, b) => b.difficulty - a.difficulty);

    setRoomsByDifficulty(downRooms);
    setLoadingDifficulty(false);
  }, [rooms]);

  const handleChange = (event, newValue) => {
    setLoading(true);
    console.log(newValue);
    setValue(newValue);
  };
  const formatTime = (time) => {
    const [hour, minute] = time.split(":");
    const period = +hour >= 12 ? "PM" : "AM";
    const formattedHour = +hour % 12 || 12;
    return `${formattedHour}:${minute} ${period}`;
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }
  if (loadingDifficulty) {
    return (
      <Box>
        <Typography>Calculating Room Difficulty...</Typography>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Today" />
          <Tab label="Tomorrow" />
        </Tabs>
      </Box>
      <Box mt={2} display="flex" justifyContent="center" alignItems="center">
        <Box width="80%">
          <Typography variant="h5" align="center">
            Employee Schedule
          </Typography>
          {filteredEmployees.map((employee) => (
            <Box
              key={employee.id}
              display="flex"
              justifyContent="space-between"
              my={1}
            >
              <Typography variant="body1">{employee.name}</Typography>
              <Typography variant="body2">
                {formatTime(
                  employee.schedule[
                    daysOfWeek[(new Date().getDay() + value) % 7]
                  ].startTime
                )}{" "}
                -
                {formatTime(
                  employee.schedule[
                    daysOfWeek[(new Date().getDay() + value) % 7]
                  ].endTime
                )}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default DispatchAssistant;
